<template>
  <div class="wrap">
    <div class="content">
      <div v-show="chanSectionDataList.length>1" @click="arrowClick('left')" class="arrow arrow-left"></div>
      <div class="title">{{ showSectionName }}</div>
      <div  v-show="chanSectionDataList.length>1" @click="arrowClick('right')" class="arrow arrow-right"></div>
    </div>
   
  </div>
</template>
<script>
import { getSectionList} from '@/utils/indexApi'
export default{
  props:{
    chanSectionDataList:{
      default: {}
    }
  },
  data(){
    return{
      title:'中铁建工一公司-霸州市区东关曲鹏改造一号公区',
      sectionList:[],
      currentIndex:0,
      showSectionName:''
    }
  },
  watch:{
    chanSectionDataList(){

    }
  },
  methods:{
    arrowClick(type){
      // debugger
      if(type==='left'){
        if(this.currentIndex===0) return
        this.currentIndex--
      }else{
        if(this.currentIndex===this.chanSectionDataList.length-1) return
        this.currentIndex++
      }
      sessionStorage.setItem('currentSection',JSON.stringify(this.chanSectionDataList[this.currentIndex]) )

      // this.$emit('changeWorkArea',this.sectionList[this.currentIndex])


      window.location.href = '/index'

    },
    getSelectionList(){

        let section = sessionStorage.getItem('currentSection')
        if(section){
          var setcionJSON = JSON.parse(section)

          for (let i = 0; i < this.chanSectionDataList.length; i++) {
            if(this.chanSectionDataList[i].id ==  setcionJSON.id){
              this.currentIndex = i;
              break;
            }
          }
        }

        this.showSectionName =  this.chanSectionDataList[this.currentIndex].sectionName;

        sessionStorage.setItem('currentSection',JSON.stringify(this.chanSectionDataList[this.currentIndex]))

    }
    
  },
  created(){
      this.getSelectionList()
    }
  }
</script>
<style scoped lang="scss">
.wrap{
  width:43.3993vw;
  height: 4.3764vw;
  margin: 0 auto;
  display: flex;
  background: url('@/assets/image/index/BG默认.png');
  background-size: contain;
  background-repeat: no-repeat;
  text-align: center;
  .content{
    width: 100%;
    padding: 0 9.7948vw;
    padding-top: 2.182vw;
    padding-bottom: 1.042vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .arrow{
      width: 1.4588vw;
      height: 0.7294vw;
    }
    .arrow-right{
      background: url("@/assets/image/situation/下拉箭头默认.png");
      transform: rotate(-90deg);
      background-repeat: no-repeat;
      background-size: contain;
    }
    .arrow-right:hover{
      background: url("@/assets/image/situation/下拉箭头高亮.png");
      transform: rotate(-90deg);
      background-repeat: no-repeat;
      background-size: contain;
    }
    .arrow-left{
      background: url("@/assets/image/situation/下拉箭头默认.png");
      transform: rotate(90deg);
      background-repeat: no-repeat;
        background-size: contain;
    }
    .arrow-left:hover{
      background: url("@/assets/image/situation/下拉箭头高亮.png");
      transform: rotate(90deg);
      background-repeat: no-repeat;
        background-size: contain;
    }
    .title{
      font-family: AlibabaPuHuiTi_2_85_Bold;
      font-size: 0.8336vw;
      color: #E5F3FF;
      line-height: 1.1462vw;
      text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
      text-align: center;
      font-style: normal;
      flex: 1;
    }
  }
  
}
.wrap:hover{
  background: url('@/assets/image/index/BG移入.png');
  background-size: contain;
  background-repeat: no-repeat;
  .title{
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size:0.8336vw;
    color: #E5F3FF;
    line-height:  1.1462vw;
    text-shadow: -1px -1px 2px rgba(26,204,255,0.5), 0px 2px 4px rgba(0,0,0,0.5);
    text-align: center;
    font-style: normal;
    }
}
</style>